import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArticleIcon from "@mui/icons-material/Article";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../api/snackbarSlice";
import { apiClient } from "../../../utils/axios";

const filenameFromDisposition = (disposition) => {
  if (typeof disposition !== "string") {
    return undefined;
  }
  const extended = /filename\*=UTF-8''([^";]+)/i.exec(disposition);
  if (extended) {
    return decodeURIComponent(extended[1].trim());
  }
  const plain = /filename="([^"]+)"/i.exec(disposition);
  if (plain && !plain[1].startsWith("=?")) {
    return plain[1];
  }
  return undefined;
};

const ReportActionsMenu = ({ jobId, disabled = false }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = async () => {
    try {
      dispatch(showSnackbar({ message: "Downloading...", severity: "info" }));

      const response = await apiClient.get(`/jobs/${jobId}/download`, {
        responseType: "blob",
        headers: {
          "Content-Type": undefined,
        },
      });

      const fileData = response.data;
      if (!(fileData instanceof Blob) || fileData.size === 0) {
        throw new Error("Empty file received");
      }

      const headers = response.headers || {};
      const disposition = headers["content-disposition"];
      const finalFileName =
        filenameFromDisposition(disposition) || "report.xlsx";

      const downloadUrl = window.URL.createObjectURL(fileData);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", finalFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      dispatch(
        showSnackbar({
          message: "File downloaded successfully!",
          severity: "success",
        }),
      );
    } catch (error) {
      console.error("Download error:", error);
      dispatch(
        showSnackbar({
          message: "Error downloading file. Please try again later.",
          severity: "error",
        }),
      );
    } finally {
      handleClose();
    }
  };

  return (
    <>
      <IconButton
        aria-label={"more"}
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
        sx={{ cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem onClick={handleDownload} disabled={!jobId}>
          <ArticleIcon sx={{ mr: 1 }} />
          {"Download Report"}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ReportActionsMenu;
